import * as Yup from "yup";

import {
  DASHBOARD_CHART_TIME_RANGES,
  DashboardChart,
  DashboardChartTimeRange,
  MAX_DASHBOARD_CHARTS,
} from "@/lib/types/website.ts";

export interface DashboardFormChartsFields {
  charts_show_section: boolean;
  charts: DashboardChart[];
}

/** A new row starts on a window that suits most charts; the user picks the chart itself. */
export const DEFAULT_CHART_TIME_RANGE: DashboardChartTimeRange = "LAST_24_HOURS";

export const DashboardFormChartsSchema = Yup.object({
  charts_show_section: Yup.boolean().required(),
  charts: Yup.array()
    .of(
      Yup.object({
        view_id: Yup.number().required("Choose a chart"),
        time_range: Yup.string().oneOf(DASHBOARD_CHART_TIME_RANGES).required(),
      })
    )
    .max(MAX_DASHBOARD_CHARTS, `A dashboard can show at most ${MAX_DASHBOARD_CHARTS} charts`)
    .defined(),
});

export const DashboardFormChartsDefaults: DashboardFormChartsFields = {
  charts_show_section: false,
  charts: [],
};
